export default {
  // 设置页面
  PickGameTitle: "挑人转盘-游戏设定",
  candidatesLabel: "候选名字设定",
  candidatesPlaceholder: "输入候选名字，并以逗号(,)分隔，按下Enter新增项目，最大候选数为20人，超过10人则随机挑选",
  clearSettings: "清空设定",
  saveSettings: "保存设定", 
  candidateExists: "候选人已存在",
  maxCandidates: "最多只能添加20位候选人",
  
  // 游戏页面
  gameTitle: "挑人转盘",
  spinWheel: "转动转盘",
  winner: "获胜者",
  spinAgain: "再转一次",
  backToSettings: "返回设定"
}